import * as type from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    downlineAgent: {}
};

const agentReducer = createReducer(initialState)({
    [type.GET_DOWNLINE_AGENT]: (state, action) => ({
        ...state,
        downlineAgent: action.payload,
    }),
});

export default agentReducer;

